import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import sha1 from 'crypto';

import './styles.css';

import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import Navperfil from '../Includes/Navperfil';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import perfil from '../../assests/perfil.jpg';
import { useTranslation } from 'react-i18next';

import './styles.css';

export default function SemPermissao() {

  let tmpToken = "";
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL')
 
  const hash = sha1.createHmac('sha256', USER_EMAIL)
    .update(USER_EMAIL)
    .digest('hex');

  const USER_TOKEN_TEMP = hash;

  
  let user = Array;
  const [urlToken, setUrlToken] = useState("");
  const history = useHistory();
  const { t } = useTranslation();

  api.get(`/v4/users/me`, {
    headers: {
      'USER_EMAIL': USER_EMAIL,
      'USER_TOKEN': USER_TOKEN,
    }
  }).then(response => {
    sessionStorage.setItem('phone', response.data.phone);
    sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
    sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
  }).catch(response => {
    history.push("/");
  });

  function tokenTemporario() {
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN_TEMP);
    data.append('USER_EMAIL', USER_TOKEN);

    var config = {
      method: 'post',
      url: BASE_URL + '/v2/users/me/temporary_token',
      headers: {
        'USER_TOKEN': USER_TOKEN,
        'USER_EMAIL': USER_EMAIL,
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        tmpToken = response.data.token;
        const urlToken = BASE_URL + '/users/me/subscriptions/me?token=' + tmpToken;
        sessionStorage.setItem('urlToken', urlToken)
      })
      .catch(function (error) {
      });

  }
  function UrlToken() {
    return (
      <button onClick={abreURL} className="btn-plano"> {t('pages.withoutPermission.buttons.updatePlan')} </button> 
    );

  }

  tokenTemporario();
  function abreURL(){
    window.location = sessionStorage.getItem('urlToken');
  }
  return (
    <div className="sempermissao-container">
      <Header />
      <Navperfil />
      <TituloPagina titulo="ACESSO NEGADO" />
      <section className="body">
        <div className="conteudo">
          <div className="interesses">
            <h2>{t('pages.withoutPermission.title')}</h2>
            {
              JSON.parse(sessionStorage.getItem('tags')).map(tags => (
                <span className="tags">{tags.name}</span>
              ))
            }
          </div>
          <div className="plano">
            <h2>{t('pages.withoutPermission.subTitle')}</h2>
            <p>{JSON.parse(sessionStorage.getItem('plan')).name}</p>
            <p>{JSON.parse(sessionStorage.getItem('plan')).description}</p>
          </div>
          <UrlToken />
          
        </div>

      </section>
      <Footer />
    </div>
  )
}